/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letters_Detail_Toast_RegeneratedInputs */

const en_cover_letters_detail_toast_regenerated = /** @type {(inputs: Cover_Letters_Detail_Toast_RegeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cover letter regenerated`)
};

const de_cover_letters_detail_toast_regenerated = /** @type {(inputs: Cover_Letters_Detail_Toast_RegeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anschreiben neu generiert`)
};

const fr_cover_letters_detail_toast_regenerated = /** @type {(inputs: Cover_Letters_Detail_Toast_RegeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lettre de motivation régénérée`)
};

const es_cover_letters_detail_toast_regenerated = /** @type {(inputs: Cover_Letters_Detail_Toast_RegeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carta de presentación regenerada`)
};

const it_cover_letters_detail_toast_regenerated = /** @type {(inputs: Cover_Letters_Detail_Toast_RegeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lettera di presentazione rigenerata`)
};

const nl_cover_letters_detail_toast_regenerated = /** @type {(inputs: Cover_Letters_Detail_Toast_RegeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivatiebrief opnieuw gegenereerd`)
};

const pl_cover_letters_detail_toast_regenerated = /** @type {(inputs: Cover_Letters_Detail_Toast_RegeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List motywacyjny wygenerowany ponownie`)
};

const fi_cover_letters_detail_toast_regenerated = /** @type {(inputs: Cover_Letters_Detail_Toast_RegeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saatekirje luotu uudelleen`)
};

const da_cover_letters_detail_toast_regenerated = /** @type {(inputs: Cover_Letters_Detail_Toast_RegeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansøgningsbrev genskabt`)
};

const sv_cover_letters_detail_toast_regenerated = /** @type {(inputs: Cover_Letters_Detail_Toast_RegeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personligt brev omgenererat`)
};

/**
* | output |
* | --- |
* | "Cover letter regenerated" |
*
* @param {Cover_Letters_Detail_Toast_RegeneratedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_detail_toast_regenerated = /** @type {((inputs?: Cover_Letters_Detail_Toast_RegeneratedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_Detail_Toast_RegeneratedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_detail_toast_regenerated(inputs)
	if (locale === "fr") return fr_cover_letters_detail_toast_regenerated(inputs)
	if (locale === "es") return es_cover_letters_detail_toast_regenerated(inputs)
	if (locale === "it") return it_cover_letters_detail_toast_regenerated(inputs)
	if (locale === "nl") return nl_cover_letters_detail_toast_regenerated(inputs)
	if (locale === "pl") return pl_cover_letters_detail_toast_regenerated(inputs)
	if (locale === "fi") return fi_cover_letters_detail_toast_regenerated(inputs)
	if (locale === "da") return da_cover_letters_detail_toast_regenerated(inputs)
	if (locale === "sv") return sv_cover_letters_detail_toast_regenerated(inputs)
	return en_cover_letters_detail_toast_regenerated(inputs)
});